import { type BreadcrumbItem } from "@/composites/navigation";
import { type SuperCategory } from "@/domain/product-listing";

/**
 * Maps a super-category to the breadcrumb chain (Home → category). The trailing
 * entry omits `href` so DS renders it as the current page. Mirrors the PDP's
 * per-surface `build-breadcrumb-items` helper.
 */
export function buildPlpBreadcrumbItems(
	category: SuperCategory,
	options: { homeUrl: string }
): BreadcrumbItem[] {
	return [{ label: "Home", href: options.homeUrl }, { label: category.name }];
}
